/**
 * Supabase browser client.
 *
 * URL + publishable (anon) key are baked in at build time from
 * VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY (set per-env in .gitlab-ci.yml).
 * Both are safe to ship in the bundle: the anon/publishable key is designed to
 * be public; row-level security + the auth hooks are the real boundary.
 *
 * When the env vars are absent (e.g. a local build with no config), the client
 * is created with placeholders and `isSupabaseConfigured` is false, so the app
 * still renders and auth simply behaves as logged-out.
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

if (!isSupabaseConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY not set. Auth is disabled in this build.',
  );
}

export const supabase: SupabaseClient = createClient(
  url ?? 'http://localhost:54321',
  anonKey ?? 'anon-key-not-configured',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  },
);
